import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    containerStyle,
    formContainerStyle,
    headerStyle,
    titleStyle,
    subtitleStyle,
    formStyle,
    errorStyle,
    buttonStyle,
    footerTextStyle,
    inputStyle
} from '../styles/globalStyles';

const Home = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try{
            // 1. Login and store token
            const formData = new URLSearchParams();
            formData.append('username', email);
            formData.append('password', ''); // Empty password since we don't need it

            const loginResponse = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData
            });

            if( ! loginResponse.ok ){
                const errorData = await loginResponse.json();

                if( loginResponse.status === 403 ){
                    if( errorData.detail === "You have not purchased this product. Please purchase it to continue." )
                        setError( 'You have not purchased this product. Please purchase it to continue.' );
                }else if( loginResponse.status === 422 ){
                    // Handle validation errors
                    if( Array.isArray( errorData.detail ) ){
                        setError( errorData.detail.map( err => err.msg ).join( ', ' ) );
                    }else if( typeof errorData.detail === 'object' ){
                        setError( JSON.stringify( errorData.detail ) );
                    }else{
                        setError( errorData.detail || 'Login failed. Please try again.' );
                    }
                }else{
                    setError( errorData.detail || 'Login failed. Please try again.' );
                }
                return;
            }

            const loginData = await loginResponse.json();

            localStorage.setItem( 'token', loginData.access_token );

            // 3. Navigate to machine IDs page
            navigate( '/machine-ids' );
        }catch( err ){
            setError('An error occurred. Please try again.');
        }
    };

    return(
        <div style={containerStyle}>
            <div style={formContainerStyle}>
                <div style={headerStyle}>
                    <h1 style={titleStyle}>REAL TRADER</h1>
                    <div style={subtitleStyle}>Launch it and let it go.</div>
                </div>
                <form onSubmit={handleSubmit} style={formStyle}>
                    {error && (
                        <div style={errorStyle}>
                            {error}
                        </div>
                    )}
                    <input 
                        placeholder="Email Address" 
                        style={inputStyle} 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        required
                    />
                    <button type="submit" style={buttonStyle}>SUBMIT</button>
                </form>
                <div style={{ ...footerTextStyle, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <svg width="18" height="18" fill="none" stroke="#b0b3b8" strokeWidth="2" viewBox="0 0 24 24"><path d="M12 17v.01"/><path d="M12 13a4 4 0 1 0-4-4"/><circle cx="12" cy="12" r="10"/></svg>
                        Your information is used only for licensing and is never shared.
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Home; 